import React from 'react';
import classes from './EventsPage.module.css';
import EventsCards from '../../ReusableComponents/EventsCards/EventsCards';
import ListStatus from '../../ReusableComponents/ListStatus/ListStatus';
import img from '../../assets/eventsBg.jpg';
import PageHeader from '../../ReusableComponents/PageHeader/PageHeader';
import useInfiniteList from '../../CustomHooks/useInfiniteList';

// Declared outside the component so their identity is stable across renders.
const selectEvents = (result) => result?.data;
const getEventKey = (event, index) => event?._id ?? event?.id ?? `event-${index}`;

function EventsPage() {
  const {
    items: events,
    loading,
    loadingMore,
    error,
    hasMore,
    sentinelRef,
    reload,
  } = useInfiniteList({
    endpoint: '/events',
    method: 'get',
    selectItems: selectEvents,
    getKey: getEventKey,
  });

  return (
    <main className={classes.eventsPage}>
      <PageHeader
        eyebrow="What’s on"
        title="Events"
        image={img}
        meta={events.length > 0 ? `${events.length} shown` : undefined}
      />
      <section className={classes.mainContainer}>
        <div className={classes.gridContainer}>
          {events.map((eventItem, index) => (
            <EventsCards key={getEventKey(eventItem, index)} data={eventItem} name={'event'} />
          ))}
        </div>

        <ListStatus
          sentinelRef={sentinelRef}
          loading={loading}
          loadingMore={loadingMore}
          error={error}
          hasMore={hasMore}
          isEmpty={events.length === 0}
          onRetry={reload}
          emptyLabel="No events to show yet."
          endLabel="No more events."
        />
      </section>
    </main>
  );
}

export default EventsPage
